<template>
    <div class="about-social" v-if="pageSetup != null">
        <aboutSocialCorp></aboutSocialCorp>
        <aboutSocialCivil></aboutSocialCivil>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import aboutSocialCorp from '@/components/about-page/about-social-corp.vue'
    import aboutSocialCivil from '@/components/about-page/about-social-civil.vue'
    export default {
        name: 'about-social-section',
        components: {
            aboutSocialCorp,
            aboutSocialCivil,
        },
        data () {
            return {
            }
        },
        computed: mapGetters({
            pageSetup: 'loadAboutPage',
        }),
        methods: {
            startLoader() {
                // this.$parent.$parent.$refs.topProgress.start();
            },
        },
        beforeCreate() {
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/about-page/about-social.scss';
    @import '@/styles/components/about-page/respond/about-social-respond.scss';
</style>